import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { PreventDefaultModule } from '@portal-core/general/directives/prevent-default/prevent-default.module';
import { TaskBoardAvatarModule } from '@portal-core/task-boards/components/task-board-avatar/task-board-avatar.module';
import { TaskBoardDeleteFormModule } from '@portal-core/task-boards/components/task-board-delete-form/task-board-delete-form.module';
import { TaskBoardSettingsFormModule } from '@portal-core/task-boards/components/task-board-settings-form/task-board-settings-form.module';
import { SwitchBoardModule } from '@portal-core/ui/switch-board/switch-board.module';
import { TaskBoardProfileDialogComponent } from './task-board-profile-dialog.component';

@NgModule({
  declarations: [
    TaskBoardProfileDialogComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatTabsModule,
    MatListModule,
    SwitchBoardModule,
    LoaderModule,
    ErrorsExpansionPanelModule,
    PreventDefaultModule,
    RouterModule,
    TaskBoardAvatarModule,
    TaskBoardDeleteFormModule,
    TaskBoardSettingsFormModule
  ],
  exports: [
    TaskBoardProfileDialogComponent
  ]
})
export class TaskBoardProfileDialogModule { }
